import React, { Component } from 'react';
import './css/Loading.css';

class LoadingScreen extends Component {
    render() {
        return (
            <div className="loading-wrapper">
                <div className="loader" />
            </div>
        )
    }
}

export default LoadingScreen;